module.exports = __webpack_public_path__ + "static/media/nullify-recreate.c53825c9.svg";